import { render, staticRenderFns } from "./index.vue?vue&type=template&id=276800be"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276800be')) {
      api.createRecord('276800be', component.options)
    } else {
      api.reload('276800be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=276800be", function () {
      api.rerender('276800be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/Sidebar/index.vue"
export default component.exports